import React from "react";

import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from "@chakra-ui/react";

import { useDeleteOutgoing } from "hooks/outgoings";

const DeleteOutgoing = ({ outgoing, closeModal, isOpen }) => {
  const toast = useToast();

  const [removeOutgoing, { isLoading }] = useDeleteOutgoing(
    {
      onSuccess: () => {
        toast({
          title: "Gasto removido com sucesso.",
          status: "success",
          duration: 5000,
          isClosable: true,
        }),
          closeModal();
      },
      onError: () => {
        toast({
          title: "Ocorreu um erro.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      },
    }
  );

  return (
    <Modal
      isCentered
      onClose={() => closeModal()}
      isOpen={isOpen}
      motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Deletar Gasto</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Tem certeza que deseja remover esse gasto?
        </ModalBody>
        <ModalFooter>
          <Button mr={3} variant="ghost" onClick={() => closeModal()}>
            Cancelar
          </Button>
          <Button
            isLoading={isLoading}
            colorScheme="red"
            onClick={() => removeOutgoing({variables: {id: outgoing?.id}})}
          >
            Confirmar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteOutgoing;
